<template>
  <div>
    <div>
      <!-- Contenedor para el código de barras -->
      <svg id="barcode"></svg>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      barcodeValue: "abc123", // Valor dinámico del código de barras
    };
  },
  watch: {
    // Observa cambios en el valor del código de barras y lo actualiza
    barcodeValue(newValue) {
      this.generateBarcode(newValue);
    },
  },
  mounted() {
    this.generateBarcode(this.barcodeValue); // Generar el código de barras al montar el componente
  },
  methods: {
    generateBarcode(value) {
      if (typeof JsBarcode !== "undefined") {
        JsBarcode("#barcode", value, {
          format: "CODE128", // Formato del código de barras
          width: 2,          // Ancho de las barras
          height: 50,        // Altura del código de barras
          displayValue: true // Mostrar el texto debajo del código de barras
        });
      } else {
        console.error("JsBarcode no está cargado. Asegúrate de incluirlo en index.html.");
      }
    },
  },
};
</script>
